export const FeaturedProjectCard = ({ project }) => {
  const { title, description, imgUrl, category, preview, about, report } = project;
  const categories = Array.isArray(category) ? category : [category];
  const isLeadership = categories.includes("Leadership");
  const isGithub = !!preview && preview.includes("github.com");
  const ctaLabel = isGithub ? "Github" : "View";

  return (
    <div className="featured-card">
      <div className="featured-card-media">
        <img src={imgUrl} alt={title} />
      </div>
      <div className="featured-card-body">
        <div className="featured-card-tags">
          {categories.map((cat) => (
            <span className="featured-card-tag" key={cat}>
              {cat}
            </span>
          ))}
        </div>
        <h4>{title}</h4>
        <p>{description}</p>
        <div className="featured-card-actions">
          <a
            href={preview}
            target="_blank"
            rel="noreferrer"
            className="featured-card-cta"
          >
            {ctaLabel} <span aria-hidden="true"></span>
          </a>
          {about && (
            <a
              href={about}
              target="_blank"
              rel="noreferrer"
              className="featured-card-cta featured-card-cta-secondary"
            >
              Learn more <span aria-hidden="true"></span>
            </a>
          )}
          {isLeadership && report && (
            <a
              href={report}
              target="_blank"
              rel="noreferrer"
              className="featured-card-cta featured-card-cta-secondary"
            >
              View report <span aria-hidden="true"></span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
